<template>
    <loader :active="loading"></loader>
    <loader-in :active="enter"></loader-in>

    <template v-if="!loading">
        <colony-selector v-if="colonyModal" :con="con" :lang="lang" :cityGroup="pendingCityGroup" @select="onColonySelected" @pickup="onColonyPickup" @close="closeColony"></colony-selector>
        <pos-switch-confirm v-if="posSwitchModal" :lang="lang" :cityName="pendingPosCity ? pendingPosCity.friendlyName : ''" @accept="confirmPosSwitch" @cancel="cancelPosSwitch"></pos-switch-confirm>
        <menu-top :view="view" :user="user" :lang="lang" :cityMenu="selectedCity" @event="filterEvent" :car="carObjets"></menu-top>
        <template v-if="cities.length > 0">
            <router-view v-slot="{ Component, route }"  @event="filterEvent">
                <transition :name="route.meta.transition" :mode="route.meta.mode">
                    <KeepAlive :include="['Menu', 'Home']" :max="10">
                        <component :is="Component" :con="con" :socket="socket" :lang="lang" :view="view" :transfer="transfer" :user="user" :cityMenu="selectedCity" :cities="cities" :car="carObjets" :lastPosition="lastPosition" class="font-1"/>
                    </KeepAlive>
                </transition>
            </router-view>
        </template>
        <footer-bottom :lang="lang" :user="user" :cityMenu="selectedCity" :cities="cities"></footer-bottom>
    </template>
</template>

<script>
import loader from "@/components/common/loaderApp.vue";
import loaderIn from "@/components/common/loaderIn.vue";
import auth from '@/assets/js/auth.js';
import  { request } from '@/assets/js/requests.js';
import  { socket } from '@/assets/js/socket.js';
import menuTop from "@/components/layout/header.vue";
import footerBottom from "@/components/layout/footer.vue";
import colonySelector from "@/components/responsive/colonySelector.vue";
import posSwitchConfirm from "@/components/responsive/posSwitchConfirm.vue";
import track from '@/assets/js/tracking.js';
//import auth from '@/assets/js/auth.js'

export default {
    name:"appGeneral",
    components:{
        menuTop,
        auth,
        loader,
        loaderIn,
        footerBottom,
        colonySelector,
        posSwitchConfirm
    },
    data(){
        return{
            enter:0,
            loading:true,
            lang:'es',
            view:'responsive',
            con:new request('https://ap15.efisense.net'),
            socket:new socket('wss://ap15.efisense.net', '9502'),
            user:{token:null,dataToken:null, data:{}, defIdentity:0},
            userDefIdentify:0,
            observer:null,
            observe:null,
            carObjets:{articles:{}, promos:[]},
            cities:[],
            colonyModal:false,
            posSwitchModal:false,
            pendingPosCity:null,
            pendingTakeoutTrack:false, //hay una eleccion de take out esperando confirmarse como aplicada
            pendingCityGroup:[],
            lastPosition:{pos:0, module:null},
            selectedCity:localStorage.cityOrigin ? JSON.parse(localStorage.cityOrigin) : null,
            transfer:{
                to:null,
                data:null
            },
        }
    },
    mounted(){
        
        this.assignUniqueId().then((res)=>{
            this.getLogin(0, true).then((resLog)=>{
                if(resLog){
                    this.getCities(localStorage.crmAuthService).then((resCity)=>{
                        this.setUserCity().then(()=>{
                            this.loading = false;
                            this.loadObserver();
                            this.maybeAskColony();
                        }).catch(err=>{err});

                    }).catch((err)=>{err});
                }else{
                    this.getCities().then((resCity)=>{

                        this.setDefaultCitie().then(()=>{
                            this.loading = false;
                            this.loadObserver();
                            this.getCarInCloud();
                            this.maybeAskColony();
                        })
                        
                    }).catch((err)=>{err});
                }
            }).catch((err)=>{err});
        }).catch((err)=>{err});


        /*this.getCities().then((res)=>{
            
            this.getLogin(0, true).then((res)=>{
                this.loadObserver();
                this.assignUniqueId().then((res)=>{
                    this.getCarInCloud();
                });
            });
        })*/
    },
    methods:{
        assignUniqueId(){ //paso 1
            return new Promise((resolve)=>{
                auth.getUnixserviceId().then((id)=>{
                    this.userDefIdentify = id;
                    this.user.defIdentity = this.userDefIdentify;
                    resolve(true)
                }).catch((err)=>{resolve(true)})
            })
        },
        getLogin(time=1000, firstLoad=false){ //paso 2
            return new Promise((resolve)=>{
                this.enter = 1;
                let [dataToken, token, pass] =  auth.vigency(...auth.getDecodedJwt(...auth.existToken()));
                if(token && pass && dataToken){
                
                    setTimeout(()=>{
                        this.con.getUserData(token).then((res)=>{
                            
                            if(res.code == 200){
                                this.enter = 2;

                                if(this.socket.wsOn === false){ //activa ws par aseguimientos y mensajes
                                    this.socket.access = token;
                                    this.socket.activeWS();
                                }

                                //guardado de los datos de usuario
                                this.user = {'token':token, 'dataToken':dataToken, 'data':res.data, 'defIdentity': this.userDefIdentify};
                                let lengthCar = 0;

                                if (Array.isArray(this.carObjets.articles)) {
                                    lengthCar = this.carObjets.articles.length;
                                } else if (this.carObjets.articles && typeof this.carObjets.articles === 'object' && this.carObjets.articles.constructor === Object) {
                                    lengthCar = Object.keys(this.carObjets.articles).length;
                                }

                                let transferData = { //mensaje a logincomponent
                                    to : ['loginLevels'],
                                    data : {
                                        recharge:new Date().getTime()
                                    }
                                }

                                this.transfer = transferData;

                                if(lengthCar == 0){ //carrito
                                    this.getCarByUserJWT().then((res1)=>{
                                        this.updateCarInCloud().then((res2)=>{
                                            setTimeout(()=>{
                                                if(!firstLoad){
                                                    this.setUserCity(false); //verificar ciudad o cambiar en caso de no corresponder
                                                }
                                                this.enter = 0;
                                                resolve(true)
                                            }, 
                                            time/2);
                                        });
                                     }); //obtiene el ultimo carrito en caso de no tener nada en la vista actual
                                }else{
                                    this.updateCarInCloud().then((res1)=>{ //sobreescribe el carrito que haya en la base de datos por usuario tener algo en memoria
                                        setTimeout(()=>{
                                            if(!firstLoad){
                                                this.setUserCity(false); //verificar ciudad o cambiar en caso de no corresponder
                                            }
                                            this.enter = 0;
                                            resolve(true)
                                        }, 
                                        time/2);
                                    });
                                }
                            }else{
                                resolve(true)
                            }
                        }).catch((err)=>{ this.filterEvent({type:'closeSession'});  resolve(true)})
                    }, time)
                }else{ //error en login por diversos temas
                    this.enter = 0;
                    this.user = {token:null,dataToken:null,data:{},defIdentity:this.userDefIdentify};
                    auth.removeLogin();
                    if(!firstLoad){ //si la funcion se ejecuto al abrir la pagina o por login desde formulario-seccion login
                        this.$router.replace({ path: '/' })
                    }
                    resolve(false)
                }
            })
        },
        getCities(token = null){ //paso 3
            return new Promise((resolve)=>{
                this.con.getCities(token).then((res)=>{
                    if(res.code == 200){
                        this.cities = res.data;
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                }).catch(()=>{
                    resolve(false)
                })
            })
        },
        getUserStoreId(){

            if(this.user.data.homes.hasOwnProperty(this.user.data.deliveryDir)){
                return this.user.data.homes[this.user.data.deliveryDir].storeNumber;
            }
           
            if(this.user.data.hasOwnProperty('storeNumber')){
                if(this.user.data.storeNumber == 0 || this.user.data.storeNumber == ''){
                    return this.cities[0].storeNumber;
                }else{
                    return this.user.data.storeNumber;
                }
            }
            return this.cities[0].storeNumber
        },
        setUserCity(initial = true){ //paso 4
            return new Promise((resolve, reject)=>{

                if(initial){ //arranque: la colonia/sucursal elegida explicitamente manda sobre la direccion default de la cuenta (evita que el reload saque al usuario del sistema donde armo su carrito)
                    const remembered = localStorage.deliveryColony ? JSON.parse(localStorage.deliveryColony) : null;
                    if(remembered){
                        const entry = this.resolveCityByStore(this.getCityGroup(remembered.friendlyName), remembered.storeNumber);
                        if(entry){
                            this.selectedCity = entry;
                            localStorage.setItem('cityOrigin', JSON.stringify(entry));
                            resolve(true);
                            return;
                        }
                    }
                }

                let uStoreId = this.getUserStoreId();
                let matched = null;

                if(uStoreId != null){ // id encontrado
                    for(let i in this.cities){
                        //match por el storeNumber de la ciudad o por su mapa de stores (las ciudades multi-sistema no traen stores)
                        if(this.cities[i].storeNumber == uStoreId || (this.cities[i].stores && Object.prototype.hasOwnProperty.call(this.cities[i].stores, uStoreId))){
                            matched = this.cities[i];
                            break;
                        }
                    }
                }

                if(matched){
                    switch(initial){
                        case true:
                            this.selectedCity = matched;
                            //console.log('cambiando a ciudad seleccionada:', matched.friendlyName)
                            localStorage.setItem('cityOrigin', JSON.stringify(this.selectedCity));
                            resolve(true);
                        break;
                        case false:{
                            const rememberedColony = localStorage.deliveryColony ? JSON.parse(localStorage.deliveryColony) : null;
                            if(rememberedColony && this.resolveCityByStore(this.getCityGroup(rememberedColony.friendlyName), rememberedColony.storeNumber)){
                                //hay colonia/sucursal elegida explicitamente: el login no saca al usuario del sistema donde armo su carrito
                                resolve(true);
                                break;
                            }
                            if(this.selectedCity.friendlyName != matched.friendlyName){
                                //cambiar solo si no es la misma ciudad puesta en memoria actualmente; la direccion del usuario ya define el sistema, no preguntamos colonia
                                this.filterEvent({type:'changeCity', city:matched, systemResolved:true});
                            }
                            resolve(true);
                        }break;
                    }
                }else{
                    this.setDefaultCitie().then((res)=>{
                        resolve(false);
                    })
                }
            });
        },
        setDefaultCitie(){ //paso 4
            return new Promise((resolve, reject)=>{
                if(this.$route.query.city){
                    let storeNumber = 6001;
                    switch(this.$route.query.city){
                        case 'mid':
                        case 'merida':
                            storeNumber = 6001;
                            break;
                        case 'mex':
                        case 'cdmx':
                            storeNumber = 6012;
                            break;
                        case 'cpe':
                        case 'campeche':
                            storeNumber = 6007;
                            break;
                        case 'queretaro':
                            storeNumber = 6023;
                            break;
                        default:
                            storeNumber = 6001;
                            break;
                    }
                    for(let i in this.cities){
                        if(this.cities[i].storeNumber == storeNumber){
                            this.selectedCity = this.cities[i];
                            //console.log('ciudad ya seleccionada por parametro get es:', this.cities[i].friendlyName)
                            localStorage.setItem('cityOrigin', JSON.stringify(this.selectedCity));
                            break;
                        }
                    }                    
                }else{
                    if(!localStorage.cityOrigin){ //si no existe un localstorage, definir una por defecto y guardar
                        this.selectedCity = this.cities[1];
                        localStorage.setItem('cityOrigin', JSON.stringify(this.selectedCity));
                        //console.log('ciudad por defecto:', this.cities[1].friendlyName)
                    }else{ // si existe iterar las ciudades hasta encontrar la misma del localstorage y sobreescribirla (por tema de expiración jwt)
                        const citySelected = JSON.parse(localStorage.cityOrigin);
                        for(let i in this.cities){
                            if(this.cities[i].storeNumber == citySelected.storeNumber){
                                this.selectedCity = this.cities[i];
                                //console.log('ciudad ya seleccionada:', this.cities[i].friendlyName)
                                localStorage.setItem('cityOrigin', JSON.stringify(this.selectedCity));
                                break;
                            }
                        }
                    }
                }
                resolve(true)
            });
        },
        getCityGroup(friendlyName){ //todas las entradas de ciudad que comparten friendlyName (un sistema/menu por entrada)
            return this.cities.filter(c => c.friendlyName == friendlyName);
        },
        isMultiSystem(friendlyName){ //ciudad con mas de un sistema -> hay que preguntar colonia
            return this.getCityGroup(friendlyName).length > 1;
        },
        resolveCityByStore(group, storeNumber){ //dentro del grupo, la entrada cuyo storeNumber (o su mapa stores) corresponde a la colonia
            for(const city of group){
                if(city.storeNumber == storeNumber){
                    return city;
                }
                if(city.stores && Object.prototype.hasOwnProperty.call(city.stores, storeNumber)){
                    return city;
                }
            }
            return null;
        },
        carHasItems(){
            for(let i in this.carObjets.articles){
                for(let j in this.carObjets.articles[i]){
                    if(this.carObjets.articles[i][j].quantity > 0){ return true; }
                }
            }
            return false;
        },
        posOf(city){ //familia de POS de un sistema (los idReference solo son compatibles dentro de la misma familia)
            return city && city.systemPOS ? city.systemPOS : '';
        },
        applyCity(city){ //swap real de ciudad/menu (remonta los componentes para recargar endpoints con el token correcto)
            //cruce entre familias de POS (ej. Positouch <-> simphony): el carrito no se puede recotizar, avisar antes de vaciar
            if(this.selectedCity && this.carHasItems() && this.posOf(city) != this.posOf(this.selectedCity)){
                if(this.pendingTakeoutTrack){
                    //eligio sucursal de take out y en vez de su menu recibe un "vamos a vaciar tu carrito"
                    track.tag('takeout_conflicto_carrito');
                }
                this.pendingPosCity = city;
                this.posSwitchModal = true;
                return;
            }
            this.doApplyCity(city);
        },
        confirmPosSwitch(){ //usuario acepto: vaciar carrito (local y en nube) y aplicar la ciudad pendiente
            const city = this.pendingPosCity;
            this.posSwitchModal = false;
            this.pendingPosCity = null;
            if(city == null){ return; }
            this.carObjets.articles = {};
            this.carObjets.promos = [];
            //vaciar tambien el carrito en la nube para que getCar no reviva items del otro catalogo
            this.con.saveCar({order:{}, idFront:this.user.defIdentity}, (this.user.token != null ? this.user.token : city.token), city.storeNumber).catch((err)=>{err});
            this.doApplyCity(city);
        },
        cancelPosSwitch(){ //usuario cancelo: se queda en la ciudad/sistema actual
            if(this.pendingTakeoutTrack){
                track.tag('takeout_abortado_por_carrito'); //eligio sucursal pero prefirio conservar su carrito
                this.pendingTakeoutTrack = false;
            }
            this.posSwitchModal = false;
            this.pendingPosCity = null;
        },
        doApplyCity(city){
            if(this.pendingTakeoutTrack){
                track.tag('takeout_aplicado'); //swap real hecho: aqui si llego al menu en modo take out
                this.pendingTakeoutTrack = false;
            }
            this.loading = true;
            this.selectedCity = city;
            localStorage.setItem('cityOrigin', JSON.stringify(city));
            setTimeout(()=>{
                this.loading = false;
            }, 2000)
        },
        askColony(friendlyName){ //abre el modal de colonia para una ciudad multi-sistema
            this.pendingCityGroup = this.getCityGroup(friendlyName);
            this.colonyModal = true;
        },
        onColonySelected(colony){ //colonia elegida: resolvemos el sistema (storeNumber) y aplicamos esa entrada de ciudad
            const entry = this.resolveCityByStore(this.pendingCityGroup, colony.storeNumber);
            if(!entry){
                //el usuario ya eligio pero el modal se queda igual: se ve como un clic que no hace nada
                track.tag('colonia_sin_sistema');
                track.variable('colonia_store_huerfano', colony.storeNumber);
                return; //sin coincidencia (el modal muestra el aviso de cobertura)
            }
            localStorage.setItem('deliveryColony', JSON.stringify({
                friendlyName: entry.friendlyName,
                storeNumber: colony.storeNumber,
                colony: colony.d_asenta || ''
            }));
            this.colonyModal = false;
            this.pendingCityGroup = [];
            this.applyCity(entry);
        },
        onColonyPickup(payload){ //colonia sin reparto: el usuario decide recoger en sucursal, aplicamos el sistema de esa tienda
            const entry = this.resolveCityByStore(this.pendingCityGroup, payload.storeNumber);
            if(!entry){
                //eligio sucursal y el modal no avanza: la falla mas grave de la funcion nueva
                track.tag('takeout_sin_sistema');
                track.variable('takeout_store_huerfano', payload.storeNumber);
                return;
            }
            localStorage.setItem('deliveryColony', JSON.stringify({
                friendlyName: entry.friendlyName,
                storeNumber: payload.storeNumber,
                colony: payload.colony && payload.colony.d_asenta ? payload.colony.d_asenta : ''
            }));
            this.colonyModal = false;
            this.pendingCityGroup = [];
            track.variable('takeout_sucursal_num', payload.storeNumber);
            //el tag de exito NO va aqui: applyCity puede frenarse en el modal de cambio de POS
            //y el usuario acabar sin sucursal aplicada. Se marca en doApplyCity, que es el swap real.
            this.pendingTakeoutTrack = true;
            this.applyCity(entry);
        },
        closeColony(){
            this.colonyModal = false;
            this.pendingCityGroup = [];
        },
        maybeAskColony(){ //tras resolver ciudad en el arranque: si es multi-sistema y no hay colonia recordada valida, preguntar
            if(!this.selectedCity){ return; }
            const group = this.getCityGroup(this.selectedCity.friendlyName);
            if(group.length <= 1){ return; }

            //la colonia/sucursal elegida explicitamente es la intencion mas reciente del usuario:
            //tiene prioridad sobre el sistema derivado de la cuenta (evita que el reload post-login saque al usuario del sistema donde armo su carrito)
            const remembered = localStorage.deliveryColony ? JSON.parse(localStorage.deliveryColony) : null;
            if(remembered && remembered.friendlyName == this.selectedCity.friendlyName){
                const entry = this.resolveCityByStore(group, remembered.storeNumber);
                if(entry){
                    this.selectedCity = entry;
                    localStorage.setItem('cityOrigin', JSON.stringify(entry));
                    return;
                }
            }

            //usuario logueado sin colonia recordada: si su direccion ya apunta a un sistema de este grupo, lo usamos sin preguntar
            if(this.user && this.user.token){
                const entryByUser = this.resolveCityByStore(group, this.getUserStoreId());
                if(entryByUser){
                    this.selectedCity = entryByUser;
                    localStorage.setItem('cityOrigin', JSON.stringify(entryByUser));
                    return;
                }
            }
            this.askColony(this.selectedCity.friendlyName);
        },
        loadObserver(){ //paso 5
            this.observe = document.querySelectorAll("[observe]");
            this.observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.setOnAction(entry.target)
                        } else {
                            this.setOffAction(entry.target)
                        }
                    });
                },
                {
                    rootMargin: '-50% 0% -50% 0%',
                    treshold: 0
                }
            );
            this.observe.forEach((entry) => {
                this.observer.observe(entry);
            });
        },
        setOnAction(elm){
            switch(elm.getAttribute('observe')){
                case 'categoryContent':
                    let tranferData = {
                        to : ['MenuGeneral', 'MenuHome'],
                        data : elm
                    }
                    this.transfer = tranferData;
                    break;
                default:
                    break;
            }
        },
        setOffAction(elm){
            switch(elm.getAttribute('observe')){
                case 'categoryContent':
                    break;
                default:
                    break;
            }
        },
        getCarPricesPerStore(){
            this.con.getCar({id:'/'+this.user.defIdentity, token:(this.user.token != null ? this.user.token : this.selectedCity.token), storeNumber:this.selectedCity.storeNumber}).then((res)=>{
                if(res.code == 200 && res.data != '' && res.data != null){
                    this.carObjets.articles = JSON.parse(res.data.articles);
                    this.carObjets.promos = res.data.promos;
                    return true
                }
                this.carObjets.promos = [{type:'amount', name:'test', give:70}];
                return true
            }).catch((err)=>{});   
        },
        getCarByUserJWT(){ //paso 6
            return new Promise((resolve)=>{
                if(this.user.token != null){
                    this.con.getCar({id:'', token:this.user.token, storeNumber:this.selectedCity.storeNumber}).then((res)=>{
                        if(res.code == 200 && res.data != '' && res.data != null){
                            this.carObjets.articles = JSON.parse(res.data.articles);
                            this.carObjets.promos = res.data.promos;
                        }
                        this.carObjets.promos = [];
                        resolve(true)
                    }).catch(()=>{resolve(false)});
                }else{
                    resolve(false)
                }
            })

        },
        getCarInCloud(){ //paso 6
            this.con.getCar({id:'/'+this.user.defIdentity, token:(this.user.token != null ? this.user.token : this.selectedCity.token), storeNumber:this.selectedCity.storeNumber}).then((res)=>{
                if(res.code == 200 && res.data != '' && res.data != null){
                    this.carObjets.articles = JSON.parse(res.data.articles);
                    this.carObjets.promos = res.data.promos;
                    return true
                }
                this.carObjets.promos = [];
            }).catch((err)=>{
                if(err.hasOwnProperty('request')){
                    if(err.request.status == 401){
                        this.filterEvent({type:'closeSession', noEraseCar:true});
                    }
                }else{
                    console.log(err); this.carObjets.articles = {}; this.carObjets.promos = [];
                }
            });            
        },
        updateCarPromo(promo=''){
            return new Promise((resolve)=>{
                this.con.saveCar({order:this.carObjets.articles, idFront:this.user.defIdentity, tryPromo:[promo]}, (this.user.token != null ? this.user.token : this.selectedCity.token), this.selectedCity.storeNumber).then((res)=>{
                    if(res.code == 200){
                        if(res.data != null){

                            
                            
                            if(res.data.hasOwnProperty('promos')){
                                this.carObjets.promos = res.data.promos;
                                resolve(true);
                            }

                            let transferData = { //mensaje a logincomponent
                                to : ['carOrder'],
                                data : {
                                    promoPending:promo,
                                    msjPromo:(res.data.hasOwnProperty('coupon')) ? res.data.coupon : ''
                                }
                            }
                            this.transfer = transferData;
                            return true;
                        }
                    }
                    //this.carObjets.promos=[];
                    resolve(true);
                }).catch((err)=>{
                    if(err && err.hasOwnProperty('request')){
                        if(err.request.status == 401){
                            this.filterEvent({type:'closeSession', noEraseCar:true});
                        }
                    }else{
                        console.log(err);this.carObjets.promos=[];
                    }
                    resolve(false);
                });
            })
        },
        updateCarInCloud(coupon=false){
            return new Promise((resolve)=>{
                let req = {order:this.carObjets.articles, idFront:this.user.defIdentity};
                if(coupon){
                    req.tryPromo = [coupon];
                }
                this.con.saveCar(req, (this.user.token != null ? this.user.token : this.selectedCity.token), this.selectedCity.storeNumber).then((res)=>{
                    if(res.code == 200){
                        if(res.data != null){
                            if(res.data.hasOwnProperty('promos')){
                                this.carObjets.promos = res.data.promos;
                                resolve(true);
                                return true
                            }
                        }
                    }
                    this.carObjets.promos=[];
                    resolve(true);
                }).catch((err)=>{
                    if(err && err.hasOwnProperty('request')){
                        if(err.request.status == 401){
                            this.filterEvent({type:'closeSession', noEraseCar:true});
                        }
                    }else{
                        console.log(err);this.carObjets.promos=[];
                    }
                    resolve(false);
                });
            })
        },
        filterEvent(data){
            switch(data.type){
                case "updateSession":
                    this.getLogin(data.time);
                    break;
                case "loginReplaceNew":
                    auth.getUnixserviceId(true).then((id)=>{
                        this.userDefIdentify = id; //nuevo id unique
                        this.user = {token:null,dataToken:null,data:{},defIdentity:this.userDefIdentify}; //reset de objeto user
                        auth.removeLogin(); //retiro de localstorage
                    }).catch((err)=>{console.log('error id')})
                    break;
                case "erasePreNumber":
                    this.user = {token:null,dataToken:null,data:{},defIdentity:this.userDefIdentify};
                    auth.removeLogin()
                    break;
                case "closeSession":
                    if(this.socket.wsOn === true){
                        this.socket.access = '';
                        this.socket.wsOn = false;
                        this.socket.forceCloseWS();
                    }
                    this.$router.push({ path: '/' })
                    auth.getUnixserviceId(true).then((id)=>{
                        this.userDefIdentify = id; //nuevo id unique
                        this.user = {token:null,dataToken:null,data:{},defIdentity:this.userDefIdentify}; //reset de objeto user
                        auth.removeLogin(); //retiro de localstorage
                        if(!data.hasOwnProperty('noEraseCar')){
                            this.carObjets = {articles:{}, promos:[]}; //borrado de carrito
                        }
                    }).catch((err)=>{console.log('error id')})
                    break;
                case "updateObserver":
                    this.loadObserver();
                    break;
                case "changeCity":
                    //si la ciudad tiene mas de un sistema (varias entradas con el mismo friendlyName) pedimos colonia para elegir el menu correcto
                    if(!data.systemResolved && this.isMultiSystem(data.city.friendlyName)){
                        this.askColony(data.city.friendlyName);
                        break;
                    }
                    if(!data.systemResolved){ //cambio explicito del usuario a otra ciudad: la colonia/sucursal recordada ya no aplica
                        const rememberedCity = localStorage.deliveryColony ? JSON.parse(localStorage.deliveryColony) : null;
                        if(rememberedCity && rememberedCity.friendlyName != data.city.friendlyName){
                            localStorage.removeItem('deliveryColony');
                        }
                    }
                    this.applyCity(data.city);
                    break;
                case "lastPosition":
                    this.lastPosition = {...data};
                    break;

                case "rechargeCarWithStoreJWT":
                    this.getCarPricesPerStore();
                    break;

                case "editQuantityIntoCar":
                    for(let i in this.carObjets.articles){
                        for(let j in this.carObjets.articles[i]){
                            if(data.id == this.carObjets.articles[i][j].id){
                                this.carObjets.articles[i][j].quantity = data.quantity;
                                this.updateCarInCloud(data.coupon);
                                break;
                            }
                        }
                    }
                    break;

                case "editPromoIntoCar":
                    this.updateCarPromo(data.coupon);
                    break;

                case "editIntoCar":

                    for(let i in this.carObjets.articles){
                        for(let j in this.carObjets.articles[i]){
                            if(data.id == this.carObjets.articles[i][j].id){

                                this.carObjets.articles[i][j].options = data.data[0];
                                this.carObjets.articles[i][j].quantity = data.data[1];
                                this.carObjets.articles[i][j].price = data.data[2];
                                this.carObjets.articles[i][j].name = data.data[3];
                                this.carObjets.articles[i][j].catUrl = data.data[4];
                                this.carObjets.articles[i][j].baseId = data.data[5];
                                this.carObjets.articles[i][j].versionSelected = data.data[6];
                                this.carObjets.articles[i][j].image = data.data[7];
                                this.updateCarInCloud();

                                break;
                            }
                        }
                    }
                    break;
                case "addToCar":

                    let nElement = {id:new Date().getTime(), options:{}, price:0, quantity:0, name:"", catUrl:'', baseId:0, versionSelected:""};
                    nElement.options = data.data[0];
                    nElement.quantity = data.data[1];
                    nElement.price = data.data[2];
                    nElement.name = data.data[3];
                    nElement.catUrl = data.data[4];
                    nElement.baseId = data.data[5];
                    nElement.versionSelected = data.data[6];
                    nElement.image = data.data[7];

                    if(this.carObjets.articles.hasOwnProperty(data.data[8])){ //categoria existe?
                        this.carObjets.articles[data.data[8]].push(nElement);
                    }else{
                        this.carObjets.articles[data.data[8]] = [];
                        this.carObjets.articles[data.data[8]].push(nElement);
                    }

                    this.updateCarInCloud();

                    break;

                case "removeToCar":
                    for(let i in this.carObjets.articles){
                        for(let j in this.carObjets.articles[i]){
                            if(data.id == this.carObjets.articles[i][j].id){
                                this.carObjets.articles[i].splice(j, 1);
                                if(this.carObjets.articles[i].length == 0){
                                    delete this.carObjets.articles[i];
                                }
                                this.updateCarInCloud(data.coupon);
                                break;
                            }
                        }
                    }
                    break;
                case "removeCar":
                    this.carObjets = {articles:{}, promos:[]};
                    this.updateCarInCloud();
                    break;
            }
        }
    }
}
</script>

<style lang="scss">
    body{
        overflow-x: hidden;
        overflow-y: overlay;
        transition: margin-right 0.3s ease;
    }
    @media (max-width: 768px) {  
        body{
            width:100vw;
        }
    }
    body:not(.modalOpen){
        margin-right: 0px !important;
    }
    #app {
        position: relative;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }

    

    /* transiciones */

    .scale-enter-active,
    .scale-leave-active {
        transition: all 0.1s ease;
    }
    .scale-enter-from,
    .scale-leave-to {
        opacity: 0;
        transform: scale(0.9);
    }

    body::-ms-scrollbar {
        display: none;
    }
    body::-webkit-scrollbar {
        width: 10px;
    }
    body::-webkit-scrollbar-track {
        background: transparent;
    }
    body::-webkit-scrollbar-thumb {
        background: linear-gradient(45deg, #BE2A34, #c9525a, #BE2A34);
        height: 62px;
    }
    
</style>
